// extracted by mini-css-extract-plugin
export default {"root":"IconPerson_root__XWl6L"};